import { useEffect, useState } from "react";
import { useFirestore } from "react-redux-firebase";
import { FIRESTORE_SUPPLIERS_TABLE } from "../../constants/FirestoreConstant";

export const useSuppliers = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const firestore = useFirestore();

  useEffect(() => {
    const unsubscribe = firestore.collection(FIRESTORE_SUPPLIERS_TABLE).onSnapshot(
      (snapshot) => {
        const suppliersData = [];
        snapshot.forEach((doc) => {
          suppliersData.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        setSuppliers(suppliersData);
        setLoading(false);
      },
      (err) => {
        console.error("Error fetching suppliers:", err);
        setError(err);
        setLoading(false);
      },
    );

    return () => unsubscribe();
  }, [firestore]);

  return { suppliers, loading, error };
};
